import { getNutritionEntityDisplayName } from "../shared/nutritionEntityNameUtils";

function getFiniteNumber(value, fallback = 0) {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : fallback;
}

export function sortNutritionEquivalents(
  equivalents,
  sortField = null,
  language = "en",
) {
  if (!Array.isArray(equivalents)) {
    return [];
  }

  if (!sortField) {
    return equivalents;
  }

  return [...equivalents].sort((leftEquivalent, rightEquivalent) => {
    const leftValue = getFiniteNumber(leftEquivalent?.[sortField]);
    const rightValue = getFiniteNumber(rightEquivalent?.[sortField]);

    if (rightValue !== leftValue) {
      return rightValue - leftValue;
    }

    return getNutritionEntityDisplayName(
      "equivalent",
      leftEquivalent,
      language,
    ).localeCompare(
      getNutritionEntityDisplayName("equivalent", rightEquivalent, language),
      undefined,
      { sensitivity: "base" },
    );
  });
}
